export class AssertException extends Error {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertException.prototype);
  }
}
